import { PdfViewer } from '@matangot/react-pdf-viewer';
import '@matangot/react-pdf-viewer/styles.css';
import React, { useState } from 'react';
import { AiOutlineDownload } from "react-icons/ai";
import { HiOutlineExternalLink } from "react-icons/hi";
import { IoMdCloseCircleOutline } from 'react-icons/io';
import Modal from 'react-modal';
import './pdf.css';

interface PDFProps {
    message?: any; 
}

Modal.setAppElement('#root');

const Pdf: React.FC<PDFProps> = ({ message }) => {
    console.log(message, "user")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const getFileUrl = (file: any) => {
        if (typeof file === 'string') {
            const createBase64 = "data:application/pdf;base64," + file
            const byteCharacters = atob(createBase64.split(',')[1]); 
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArrays], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            return pdfUrl;
        }

        if (file instanceof Blob || file instanceof File) {
            return URL.createObjectURL(file);
        }

        return '';
    };
    const fileUrl = getFileUrl(message.file);
    return (
        <div className="PdfContainer">
            <div className='sendpdf'>
                <button>
                    {message.hasOwnProperty("fileName") ? message?.fileName : message?.text || "No text provided"}
                </button>
                <div className="pdfcss-footer">
                    <div className='pdfcss-left'>
                        <a onClick={openModal}>
                            <HiOutlineExternalLink className="pdfcss" title="View PDF" />
                        </a>
                        <a href={fileUrl} target="_blank" download>
                            <AiOutlineDownload className="pdfcss" title="Download PDF" />
                        </a>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onRequestClose={closeModal} className="pdfModal">
                <button onClick={closeModal} className="closeButton"><IoMdCloseCircleOutline /></button>
                <PdfViewer src={fileUrl} />
            </Modal>
        </div>
    );
};
export default Pdf;


